import {useComEvent} from "@/main-page/ctls/hooks/useComEvent";
import {regeditEngineEvent, removeEngineEvent} from "@/main-page/utils/FunctionEngineUtils";

export function useComDataInterface({tansToEditorEvent, ctlFrom, emits, events, commonTabRef, props = {}}: any) {

  const {clickEvent} = useComEvent({events});

  /**
   * 保存记录
   */
  const saveRecord = ({record}: any) => {
    emits('saveRecord', {record});
  }

  /**
   * 选中首行
   */
  const selFirstRow = ({records}) => {
    const tableObj = document.getElementById(unref(props).key);
    if (tableObj) {
      const body: any = tableObj.querySelector(".ant-table-tbody");
      if (body) {
        const elObj = body.querySelector('.ant-table-row');
        if (elObj) {
          let oldClas = elObj.className;
          oldClas = (oldClas + '').replace(/curActiveRow/, '');
          elObj.className = oldClas + ' curActiveRow';
        }
        if (records[0]) {
          clickEvent('rowSelect', {
            recordId: records[0].id,
            recordIds: [records[0].id],
            id: records[0].id,
            record: records[0],
            records: [records[0]]
          });
        }
      }
    }
  }


  /**
   * 数据加载完成事件
   * @param records
   */
  const afterLoadData = ({records}) => {
    if (records && unref(records).records && Array.isArray(unref(records).records)) {
      records = unref(records).records;
    }
    emits && emits('afterLoadData', {records});
    if (records && Array.isArray(records) && records.length > 0) {
      tansToEditorEvent && tansToEditorEvent({records});
    }
    //如果是子表 则不执行 由子表来执行
    if (ctlFrom !== 'xmSubTable') {
      clickEvent('afterLoadData', {
        id: unref(records) && unref(records)[0] && unref(records)[0].id,
        record: unref(records) && unref(records)[0],
        records: unref(records)
      });
    }

    //如果选中了首行选中
    if (unref(props).afterLoadSelRow) {
      nextTick(() => {
        selFirstRow({records});
      })
    }
  }


  /**
   * 获取表格行集合信息
   */
  const getGridRecords = () => commonTabRef.value?.getEditorRecords()

  onBeforeUnmount(() => {
    removeEngineEvent(unref(props).key, 'getGridRecords');
  })

  /**
   * 页面加载完成事件
   */
  onMounted(() => {
    regeditEngineEvent(unref(props).key, 'getGridRecords', getGridRecords);
    console.log('数据表格------------onMounted');
    clickEvent('onMounted', {});
  })

  /**
   * 单元格双击事件
   * @param record
   * @param column
   */
  const handleCellDoubleClick = ({record, column}) => {
    clickEvent('handleCellDoubleClick', {
      recordId: unref(record) && unref(record).id,
      record: unref(record),
      column: unref(column)
    });
    emits && emits('handleCellDoubleClick', {record, column});
  }


  return {
    handleCellDoubleClick,
    saveRecord,
    afterLoadData
  }

}
